import React from "react";

export type DateProps = {
    label: string;
};

/**
 * Formats the provided date string using the "en-AU" locale and returns the formatted date.
 *
 * @param {DateProps} props - An object containing the label property, which represents the date to be formatted.
 * @param {string} props.label - A string representing the date to be formatted.
 * @returns {JSX.Element | null} A React element containing the formatted date, or null if the label is falsy.
 */
const FormattedDate = ({ label }: DateProps) => {
    if (!label || isNaN(Date.parse(label))) return <></>;

    const date = new Intl.DateTimeFormat("en-AU", {
        year: "numeric",
        month: "long",
        day: "numeric",
    }).format(new Date(label));

    return <>{date}</>;
};

export default FormattedDate;
